var sampleArray = [
  {
  'id' : 1,
  'label' : '领导力与管理技能提升',
  'class' : 'A',
  'children' : [
  {
  'id' : 5,
  'label': '高阶主管的培训课程',
  'class' : 'A-1',
  'children':[
  {
  'id' : 35,
  'label': '政策解读',
  'class' : 'A-1-1',
  },
  {
  'id' : 36,
  'label': '企业文化',
  'class' : 'A-1-2',
  },
  {
  'id' : 37,
  'label': '专业能力',
  'class' : 'A-1-3',
  }
  ]
  },
  {
  'id' : 6,
  'label': '中层管理干部培训课程',
  'class' : 'A-2',
  'children':[
  {
  'id' : 38,
  'label': '人员管理',
  'class' : 'A-2-1',
  },
  {
  'id' : 39,
  'label': '工作管理',
  'class' : 'A-2-2',
  },
  {
  'id' : 40,
  'label': '综合管理',
  'class' : 'A-2-3',
  }
  ]
  },
  {
  'id' : 7,
  'label': '中层制造主管的培训课程',
  'class' : 'A-3',
  'children':[
  {
  'id' : 41,
  'label': '政策解读',
  'class' : 'A-3-1',
  },
  {
  'id' : 42,
  'label': '企业文化',
  'class' : 'A-3-2',
  },
  {
  'id' : 43,
  'label': '专业能力',
  'class' : 'A-3-3',
  }
  ]
  },
  {
  'id' : 8,
  'label': '中基层制造主管的培训课程',
  'class' : 'A-4',
  'children':[
  {
  'id' : 44,
  'label': '政策解读',
  'class' : 'A-4-1',
  },
  {
  'id' : 45,
  'label': '企业文化',
  'class' : 'A-4-2',
  },
  {
  'id' : 46,
  'label': '专业能力',
  'class' : 'A-4-3',
  }
  ]
  },
  {
  'id' : 9,
  'label': '基层制造主管的培训课程',
  'class' : 'A-5',
  'children':[
  {
  'id' : 47,
  'label': '政策解读',
  'class' : 'A-5-1',
  },
  {
  'id' : 48,
  'label': '企业文化',
  'class' : 'A-5-2',
  },
  {
  'id' : 49,
  'label': '专业能力',
  'class' : 'A-5-3',
  }
  ]
  },
  {
  'id' : 10,
  'label': '个人自我管理技能培训课程',
  'class' : 'A-6',
  'children':[
  {
  'id' : 50,
  'label': '心态管理',
  'class' : 'A-6-1',
  },
  {
  'id' : 51,
  'label': '自我管理',
  'class' : 'A-6-2',
  },
  {
  'id' : 52,
  'label': '综合管理',
  'class' : 'A-6-3',
  }
  ]
  }
  ]
  },
  {
  'id' : 2,
  'label' : '岗位专业及技能提升',
  'class' : 'B',
  'children' : [
  {
  'id' : 11,
  'label': '精益IE',
  'class' : 'B-1',
  'children':[
  {
  'id' : 53,
  'label': '效率提升',
  'class' : 'B-1-1',
  },
  {
  'id' : 54,
  'label': '品质',
  'class' : 'B-1-2',
  },
  {
  'id' : 55,
  'label': '物流与供应链',
  'class' : 'B-1-3',
  },
  {
  'id' : 56,
  'label': '成本',
  'class' : 'B-1-4',
  },
  {
  'id' : 57,
  'label': '设备',
  'class' : 'B-1-5',
  }
  ]
  },
  {
  'id' : 12,
  'label': '自动化与机器人',
  'class' : 'B-2',
  'children':[
  {
  'id' : 58,
  'label': '机械设计',
  'class' : 'B-2-1',
  },
  {
  'id' : 59,
  'label': '电气设计',
  'class' : 'B-2-2',
  },
  {
  'id' : 60,
  'label': '软件设计',
  'class' : 'B-2-3',
  },
  {
  'id' : 61,
  'label': '机器人',
  'class' : 'B-2-4',
  }
  ]
  },
  {
  'id' : 13,
  'label': '信息技术',
  'class' : 'B-3',
  'children':[
  {
  'id' : 62,
  'label': '程序语言',
  'class' : 'B-3-1',
  },
  {
  'id' : 63,
  'label': '软件开发',
  'class' : 'B-3-2',
  },
  {
  'id' : 64,
  'label': 'IT架构',
  'class' : 'B-3-3',
  },
  {
  'id' : 65,
  'label': '数据库',
  'class' : 'B-3-4',
  },
  {
  'id' : 66,
  'label': '企业信息管理系统',
  'class' : 'B-3-5',
  },
  {
  'id' : 67,
  'label': '产品管理',
  'class' : 'B-3-6',
  },
  {
  'id' : 68,
  'label': '信息安全',
  'class' : 'B-3-7',
  }
  ]
  },
  {
  'id' : 14,
  'label': '大数据与人工智能',
  'class' : 'B-4',
  'children':[
  {
  'id' : 69,
  'label': '数理统计基础',
  'class' : 'B-4-1',
  },
  {
  'id' : 70,
  'label': '程序语言',
  'class' : 'B-4-2',
  },
  {
  'id' : 71,
  'label': '算法',
  'class' : 'B-4-3',
  },
  {
  'id' : 72,
  'label': '架构',
  'class' : 'B-4-4',
  },
  {
  'id' : 73,
  'label': '工业人工智能实战训练',
  'class' : 'B-4-5',
  }
  ]
  },
  {
  'id' : 15,
  'label': '物联网',
  'class' : 'B-5',
  'children':[
  {
  'id' : 74,
  'label': 'IoT硬件',
  'class' : 'B-5-1',
  },
  {
  'id' : 75,
  'label': 'IoT软件',
  'class' : 'B-5-2',
  },
  {
  'id' : 76,
  'label': 'IoT网络',
  'class' : 'B-5-3',
  },
  {
  'id' : 77,
  'label': 'IoT系统',
  'class' : 'B-5-4',
  }
  ]
  },
  {
  'id' : 16,
  'label': '研发设计',
  'class' : 'B-6',
  'children':[
  {
  'id' : 78,
  'label': '尺寸工程设计',
  'class' : 'B-6-1',
  },
  {
  'id' : 79,
  'label': '可靠性设计',
  'class' : 'B-6-2',
  },
  {
  'id' : 80,
  'label': '产品优化设计',
  'class' : 'B-6-3',
  },
  {
  'id' : 81,
  'label': '工艺研发',
  'class' : 'B-6-4',
  },
  {
  'id' : 82,
  'label': '制造设计',
  'class' : 'B-6-5',
  },
  {
  'id' : 83,
  'label': '研发项目管理',
  'class' : 'B-6-6',
  }
  ]
  }
  ]
  },
  {
  'id' : 3,
  'label' : '专业技能认证与证书获得',
  'class' : 'C',
  'children' : [
  {
  'id' : 17,
  'label': 'PMP认证',
  'class' : 'C-1',
  },
  {
  'id' : 18,
  'label': '经济师证（人力资源方向）',
  'class' : 'C-2',
  },
  {
  'id' : 19,
  'label': '工业互联网设备安装与调试（职业资格鉴定）',
  'class' : 'C-3',
  },
  {
  'id' : 20,
  'label': '工业物联网装调与维护（三级/四级/五级）',
  'class' : 'C-4',
  },
  {
  'id' : 21,
  'label': '电工证（初级）',
  'class' : 'C-5',
  },
  {
  'id' : 22,
  'label': 'Python（二级）',
  'class' : 'C-6',
  },
  {
  'id' : 23,
  'label': '信息处理技术',
  'class' : 'C-7',
  },
  {
  'id' : 24,
  'label': '程序员',
  'class' : 'C-8',
  },
  {
  'id' : 25,
  'label': '系统集成项目管理工程师',
  'class' : 'C-9',
  },
  ]
  },
  {
  'id' : 4,
  'label' : '前沿讲座',
  'class' : 'D',
  'children' : [
  {
  'id' : 26,
  'label': '电动车/新能源汽车',
  'class' : 'D-1',
  },
  {
  'id' : 27,
  'label': '数位医疗',
  'class' : 'D-2',
  },
  {
  'id' : 28,
  'label': '机器人',
  'class' : 'D-3',
  },
  {
  'id' : 29,
  'label': '人工智能/大数据/云计算',
  'class' : 'D-4',
  },
  {
  'id' : 30,
  'label': '半导体',
  'class' : 'D-5',
  },
  {
  'id' : 31,
  'label': '5G/6G新世代通信技术',
  'class' : 'D-6',
  },
  {
  'id' : 32,
  'label': '量子计算',
  'class' : 'D-7',
  },
  {
  'id' : 33,
  'label': '资通安全',
  'class' : 'D-8',
  },
  {
  'id' : 34,
  'label': '数位转型',
  'class' : 'D-9',
  }
  ]
  }
  ]

export function getArray() {
  return sampleArray
}
